import { CommonModule } from '@angular/common'
import { Component, OnInit } from '@angular/core'
import { LogoComponent } from '@app/v2/shared/components/logo/logo.component'
import { AuthService } from '@auth/services/auth.service'
import { take } from 'rxjs'

@Component({
  selector: 'ngx-sso-callback',
  standalone: true,
  imports: [CommonModule, LogoComponent],
  template: `
    <div class="sso-loading-overlay" aria-busy="true" aria-live="polite">
      <div class="loader-card">
        <app-logo class="brand"></app-logo>
        <div class="progress">
          <div class="bar"></div>
        </div>
        <div class="hint">Signing you in…</div>
      </div>
    </div>
  `,
  styles: [
    `
      .sso-loading-overlay {
        position: fixed;
        inset: 0;
        background: linear-gradient(180deg, rgba(249, 250, 251, 0.95), rgba(255, 255, 255, 0.9));
        backdrop-filter: blur(3px);
        z-index: 2000;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .loader-card {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 14px;
        padding: 24px 28px;
        background: #ffffff;
        border: 1px solid #e5e7eb;
        border-radius: 12px;
        box-shadow: 0 10px 30px rgba(59, 130, 246, 0.15);
      }

      .loader-card .brand {
        opacity: 0.9;
      }

      .loader-card .progress {
        width: 220px;
        height: 6px;
        background: #eef2ff;
        border-radius: 999px;
        overflow: hidden;
        position: relative;
      }

      .loader-card .progress .bar {
        position: absolute;
        width: 40%;
        height: 100%;
        left: -40%;
        background: linear-gradient(90deg, #60a5fa, #2563eb);
        border-radius: 999px;
        animation: slide 1.2s ease-in-out infinite;
      }

      .loader-card .hint {
        font-size: 13px;
        color: #6b7280;
      }

      @keyframes slide {
        0% {
          left: -40%;
        }
        50% {
          left: 60%;
        }
        100% {
          left: 100%;
        }
      }
    `
  ]
})
export class SsoCallbackComponent implements OnInit {
  constructor(private authService: AuthService) {}

  ngOnInit(): void {
    this.authService
      .getAccessToken$()
      .pipe(take(1))
      .subscribe((token) => {
        if (token) {
          this.authService.clearCrossAppRedirectState()
          window.location.replace('/')
          return
        }
        this.authService.beginLogin('/')
      })
  }
}
